import { Box, Typography } from "@mui/material";
import React, { memo } from "react";
import { useNavigate } from "react-router-dom"; // Import the useNavigate hook
import { useAppContext } from "../context/appContext";
import AppTile from "./components/AppTile";

function DashboardContent() {
  const {
    setHusibuechLoading,
    setBszFinderLoading,
    setBszPlannerLoading,
    setSonderEventLoading,
    setEventManagerLoading,
    setAskomaLoading,
    isAnAdmin,
    isATeacher,
    currentUser,
    isAReferenceStudent,
    isAStudent,
    isTeacherView,
    isStudentView,
  } = useAppContext();
  const navigate = useNavigate(); // Hook to navigate programmatically

  // Functions to handle navigation on click
  const handleClickGatterApp = () => {
    navigate("/gatterApp"); // Navigate to the "app1" page
  };
  const handleClickChatApp = () => {
    navigate("/chatApp"); // Navigate to the "app1" page
  };
  const handleClickSommerApp = () => {
    setEventManagerLoading(true);
    navigate("/eventManagerApp"); // Navigate to the "app1" page
  };
  const handleClickSonderApp = () => {
    setSonderEventLoading(true);
    navigate("/sonderApp"); // Navigate to the "app1" page
  };
  const handleClickHusibuech = () => {
    setHusibuechLoading(true);
    navigate("/husibuech"); // Navigate to the "app2" page
  };
  const handleClickBSZFinder = () => {
    setBszFinderLoading(true);
    navigate("/bszFinder");
  };
  const handleClickBSZPlanner = () => {
    setBszPlannerLoading(true);
    navigate("/bszPlanner");
  };

  const handleClickAskomaApp = () => {
    setAskomaLoading(true);
    navigate("/askoma");
  };

  return (
    <div
      style={{
        display: "flex", // Use flexbox for layout
        flexDirection: "column", // Stack items vertically (from top to bottom)
        alignItems: "center", // Center the items horizontally
        justifyContent: "center", // Center the items vertically
        minHeight: "20rem", // Ensure the container has a fixed height
        gap: "3rem", // Add gap between the items
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 500,
          textAlign: "center",
          px: 1,
          py: 2,
        }}
      >
        <Typography
          color="primary"
          variant="h5"
          fontWeight={"bold"}
          sx={{
            fontSize: { xs: "1.2rem", sm: "1.6rem" },
            lineHeight: 1.3,
            wordBreak: "break-word",
          }}
        >
          Apps in Entwicklung:
        </Typography>
      </Box>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(120px, 140px))",
          gap: "1rem",

          // ✅ center grid
          justifyContent: "center",

          // ✅ prevent stretching
          width: "100%",
          maxWidth: "700px",

          margin: "0 auto", // ✅ center horizontally
        }}
      >
        <AppTile
          label="BSZ Finder"
          image="./static/images/bszFinder/bszFinder6.png"
          onClick={handleClickBSZFinder}
        />
        {(isAnAdmin || isATeacher) && !isStudentView && (
          <AppTile
            label="BSZ Planner"
            image="./static/images/bszPlanner/bszPlanner.png"
            onClick={handleClickBSZPlanner}
          />
        )}

        <AppTile
          label="Event Manager"
          image="./static/images/eventManager/eventManager.png"
          onClick={handleClickSommerApp}
        />
        {(isATeacher || isAnAdmin) && !isStudentView && (
          <AppTile
            label="Sondertage"
            image="./static/images/sondertage/sondertage.png"
            onClick={handleClickSonderApp}
          />
        )}
        {(isAStudent || (isAnAdmin && !isTeacherView)) && (
          <AppTile
            label="GatterApp"
            image="./static/images/gatter/gatter.png"
            onClick={handleClickGatterApp}
          />
        )}
        {(isAReferenceStudent || (isAnAdmin && !isTeacherView)) && (
          <AppTile
            label="ChatApp"
            image="./static/images/team/apeFather.png"
            onClick={handleClickChatApp}
          />
        )}
        {isAnAdmin && !isTeacherView && !isStudentView && (
          <AppTile
            label="Hausaufgaben Planen"
            image="./static/images/login/logo512.png"
            onClick={handleClickHusibuech}
          />
        )}
        {isAnAdmin &&
          currentUser?.id === 205 &&
          !isTeacherView &&
          !isStudentView && (
            <AppTile
              label="Askoma Lesen"
              image="./static/images/askoma/askoma.png"
              onClick={handleClickAskomaApp}
            />
          )}
      </div>
    </div>
  );
}

export default memo(DashboardContent);
